module.exports = __webpack_public_path__ + "media/images/background/bg-shape-1-ba54a8e086d0e99d912dc930d1664b54.jpg";